"use client";

import FooterFive from "@/layouts/footers/FooterFive";
import { useEffect, useState } from "react";
import axiosInstance from "@/service/axiosInstance";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
} from "@/utils/utils";
import Loader from "@/components/Loader/Loader";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { logout } from "@/redux/features/authSlice";

import EventListingOne from "./EventListing";
import { ToastOptions } from "@/utils/enum";

const Vc3PreEventlisting = ({ module }: { module: string }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [footerData, setFooterData] = useState([[]]);
  const [socialMedia, setSocialMedia] = useState([]);

  const getData = async () => {
    try {
      const token = localStorage.getItem("token");
      setLoading(true);
      const resp: any = await axiosInstance.get("/homePage", {});
      if (token) {
        if (
          resp?.isAuthorized?.status == 401 ||
          resp?.isAuthorized?.message == "Token has expired"
        ) {
          console.log("Token has expired!");
          toast.error("Session expired please login again", ToastOptions);
          localStorage.removeItem("token");
          dispatch(logout());

          //   router.push(`/login?redirect="true"`);

          //   return;
        }
      }

      //   let updated = resp?.data;

      //   setCount(resp?.meta.pagination.total);

      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );

      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );
      setSocialMedia(socialMediaData);

      setFooterData([footerData1, footerData2, footerData3]);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <EventListingOne module={module} />
      {/* <FancyBanner /> */}
      <FooterFive data={footerData} socialMedia={socialMedia} />
    </>
  );
};

export default Vc3PreEventlisting;
